import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { paddingLR } = theme.mixins;
  return {
    root: {
      '& .questionLabel': {
        fontSize: pxToRem(14),
        lineHeight: 'normal',
        fontFamily: theme.custom.fontFamily.primaryBold,
        marginBottom: pxToRem(10),
        display: 'block',
        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(12),
        },
      },

      '& .matrixTable': {
        '& .optionLabel': {
          fontSize: pxToRem(14),
          lineHeight: 'normal',
          fontFamily: theme.custom.fontFamily.primaryBold,
          ...paddingLR(16, 16),
          [theme.breakpoints.down('md')]: {
            ...paddingLR(4, 4),
            fontSize: pxToRem(12),
          }
        },

        '& .questionStatement': {
          fontSize: pxToRem(14),
          lineHeight: 'normal',
          [theme.breakpoints.down('md')]: {
            fontSize: pxToRem(12),
          }
        },

        '& .radioTableData': {
          ...paddingLR(16, 16),
          textAlign: 'center',
          [theme.breakpoints.down('md')]: {
            ...paddingLR(4, 4),
          }
        }
      },
    },
  };
});
export default useStyles;
